import { uploadImage } from "./UploadImage";
export const UploadImageAsFormData = async (file: File, hideToastMessages?: boolean) => {
    const formData = new FormData();
    const size = file?.size || 1
    const mbSize = size / 1024 / 1024
    if (mbSize >= 10) {
        return { errorMessage: "FILE_IS_TOO_SIZE", error: true }
    }
    formData.append('file', file);
    const response = await uploadImage(formData, hideToastMessages)
    return response
}